const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  sub:state => state.user.sub,
  user:  state => state.user.user,
  refreshExpires: state => state.user.refreshExpires,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  permissions:state => state.user.permissions,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  tenants:state =>state.user.tenants,
  generateUpdateSettingsParams:state =>state.user.generateUpdateSettingsParams,
  enumMetadata:state =>state.user.enumMetadata,
}
export default getters
